import { EnvironmentType } from 'src/app/library/enums/general/environment.enum';
import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
    production: window['env']['environmentType'] != 'Local' ? true : false,
    environmentType:
        window['env']['environmentType'] == 'Local'
            ? EnvironmentType.Local
            : window['env']['environmentType'] == 'Development'
            ? EnvironmentType.Development
            : window['env']['environmentType'] == 'UAT'
            ? EnvironmentType.UAT
            : EnvironmentType.Production,
    appConfig: window['env']['appConfig'],
    configurationKey: window['env']['configurationKey'],
    configuration: window['env']['configuration']
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import "zone.js/plugins/zone-error";  // Included with Angular CLI.
